<template>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="dialog = false">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text v-html="message" @click="onClick"></v-card-text>
      <v-card-actions>
        <v-btn v-if="seconButtontext" text color="green" @click="onSecodClick"> {{seconButtontext}} </v-btn>
        <v-spacer />
        <v-btn text color="green" @click="onOkayClick"> Okay </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AlertModal from "./index";
export default {
  data() {
    return {
      message: "",
      title: "Message",
      dialog: false,
      onOkayCallback: null, // Store the callback function
      seconButtontext: "",
      secodCallBack:null
    };
  },
  methods: {
    show(message, title, callback, seconButtontext, secodCallBack) {
      const vm = this;
      vm.message = message;
      vm.title = title || "Message";
      vm.seconButtontext = seconButtontext || false;
      vm.dialog = true;
      vm.onOkayCallback = callback; // Save the callback function
      vm.onSecodCallBack = secodCallBack; // Save the callback function
    },
    onClick(e) {
      if (e.target.href) {
        window.open(e.target.href);
      }
    },
    onOkayClick() {
      if (this.onOkayCallback) {
        this.onOkayCallback(); // Call the passed callback function
      }
      this.dialog = false; // Close the dialog
    },
    onSecodClick() {
      if (this.onSecodCallBack) {
        this.onSecodCallBack(); // Call the passed callback function
      }
      this.dialog = false; // Close the dialog
    },
  },
  beforeMount() {
    AlertModal.EventBus.$on("show", (params, title, callback, seconButtontext, secodCallBack) => {
      this.show(params, title, callback, seconButtontext, secodCallBack); // Pass the callback
    });
    AlertModal.EventBus.$on("hide", () => {
      this.dialog = false;
    });
  },
};
</script>

<style></style>
